module.exports = __webpack_public_path__ + "static/media/classroom_banner.2afb1093.jpg";